.subHeader {
  max-width: 100%;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  width: 100%;
}
.comment {
  margin-left: 6px !important;
  color: #667885 !important;
}

.pointer {
  cursor: pointer;
}

.subHeaderContainer {
  position: relative;
  width: 100%;
  max-width: 100%;
  display: flex;
}

.copySubHeaderContainer {
  width: fit-content;
  box-sizing: border-box;
  cursor: pointer;
  padding-left: 12px;
  .copySubHeaderAnimationContainer {
    position: relative;
    svg {
      position: relative;
      z-index: 2;
    }

    &::before {
      content: "";
      background-color: #eaedef;
      height: 0;
      width: 0;
      position: absolute;
      left: calc(50% - 1px);
      top: 50%;
      transform: translate(-50%, -50%);
      border-radius: 100%;
      transition: height 0.25s ease-out, width 0.25s ease-out;
    }

    &:hover {
      &::before {
        transition: height 0.25s ease-in, width 0.25s ease-in;

        height: 30px;
        width: 30px;
      }
    }
  }
}
